export default __webpack_public_path__ + "static/Office_image_6-3f600b221c1b76c00e9002275ad2adea.png";